import React, { useEffect, useState } from "react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("el-consent")) setVisible(true);
    } catch (e) {}
  }, []);

  const decide = (all) => {
    try {
      localStorage.setItem("el-consent", all ? "all" : "necessary");
    } catch (e) {}
    if (all && typeof window.__enablePixel === "function") window.__enablePixel();
    window.dispatchEvent(new CustomEvent("el-consent", { detail: all ? "all" : "necessary" }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie-Einwilligung"
      className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-[560px] rounded-[16px] border border-white/12 bg-[#1e2532] p-6 text-white shadow-[0_16px_48px_rgba(0,0,0,0.4)] md:p-7"
    >
      <p className="font-display text-[17px] font-bold">Cookies & Datenschutz</p>
      <p className="mt-3 text-[14px] leading-[1.65] text-white/70">
        Wir verwenden Cookies, um unsere Website zu verbessern und den Erfolg unserer Kampagnen zu messen
        (Meta-Pixel). Sie können Ihre Auswahl jederzeit ändern. Details in unserer{" "}
        <a href="/datenschutzerklaerung/" className="font-semibold text-white underline underline-offset-2">
          Datenschutzerklärung
        </a>
        .
      </p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button
          type="button"
          data-testid="cookie-accept-all"
          onClick={() => decide(true)}
          className="btn-solid inline-flex items-center px-5 py-3 text-[12.5px] font-bold uppercase tracking-[0.06em]"
        >
          <span>Alle akzeptieren</span>
        </button>
        <button
          type="button"
          data-testid="cookie-necessary-only"
          onClick={() => decide(false)}
          className="inline-flex items-center rounded-full border border-white/25 px-5 py-3 text-[12.5px] font-bold uppercase tracking-[0.06em] text-white/80 hover:border-white/50"
        >
          Nur notwendige
        </button>
      </div>
    </div>
  );
};
